import { isEmpty } from "lodash";

class LocalStorage {
    set(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    get(key: string): string | null {
        const value = localStorage.getItem(key);
        return isEmpty(value) ? null : value;
    }
}

const customLocalStorage = new LocalStorage();
export default customLocalStorage;
